import { getLiveClaimFeedTemplate, getVueLiveClaimFeedTemplate } from "../../shortcodes/templates";

let liveClaimFeed = null;

const visualizeLiveClaimFeed = content => {
  liveClaimFeed = content.querySelectorAll('[data-wrapper-id="live-claim-feed"]');
  if (liveClaimFeed.length > 0) {
    liveClaimFeed.forEach(item => {
      item.innerHTML = getLiveClaimFeedTemplate();
    });
  }
};

const serializeLiveClaimFeed = content => {
  liveClaimFeed = content.querySelectorAll('[data-wrapper-id="live-claim-feed"]');
  if (liveClaimFeed.length > 0) {
    liveClaimFeed.forEach(item => {
      const feedData = item.getAttribute("data-live-claim-feed-data");
      item.innerHTML = getVueLiveClaimFeedTemplate(feedData);
    });
  }
};

export { visualizeLiveClaimFeed, serializeLiveClaimFeed };
